export default function Title({ heading, children }) {
    return (
        <div id='test3' className="flex flex-wrap justify-center text-center mb-25">
            <div className="w-full lg:w-6/12 px-4">
                <h3 className="text-3xl font-semibold text-gray-700">{heading}</h3>
                <div className="text-lg leading-relaxed mt-4 mb-4 text-gray-600">{children}</div>
            </div>
        </div>
    );
}
